<template>
  <div class='login-form'>
    <h3 class='modal__title'>{{ locales && locales.common && locales.common.login }}</h3>
    <div
      class='login-form__caps-warning'
      v-show='capsLockEnabled'
      v-text='locales.common && locales.common.capsWarning'
    />
    <div class='login-form__input-box'>
      <div class='login-form__label'>
        {{ locales && locales.common && locales.common.your_email }}
        <span class='login-form__label-asterisk'> *</span>
      </div>
      <div style='position: relative;'>
        <input
          :class="['login-form__input', { 'login-form__input-invalid': errors.has('email') }]"
          :placeholder='locales && locales.common && locales.common.enter_your_email'
          type='text'
          name='email'
          v-model='email'
          v-validate='`required`'
          @keyup.enter='login(email, password)'
          @keypress='checkCaps'
          @keydown='capsLockToggle'
        />
        <span
          v-if="errors.has('email')"
          class='icon-warning login-form__icon-error'
        />
      </div>
      <div class='login-form__error' v-if="errors.has('email')">
        {{ errors.first('email') }}
      </div>
    </div>
    <div class='login-form__input-box'>
      <div class='login-form__label'>
        {{ locales && locales.common && locales.common.your_password }}
        <span class='login-form__label-asterisk'> *</span>
        <div class='login-form__label-note'>
          <a href='#' class='theme-btn theme-btn--text' @click.prevent='goToForgotPassword'>{{locales && locales.common && locales.common.forgot_password}}</a>
        </div>
      </div>
      <div style='position: relative;'>
        <input
          :class="['login-form__input', { 'login-form__input-invalid': errors.has('password') }]"
          :placeholder='locales && locales.common && locales.common.enter_your_password'
          type='password'
          name='password'
          v-model='password'
          v-validate='`required`'
          @keyup.enter='login(email, password)'
          @keypress='checkCaps'
          @keydown='capsLockToggle'
        />
        <span
          v-if="errors.has('password')"
          class='icon-warning login-form__icon-error'
        />
        <span
          v-else
          class='fa fa-eye-slash'
          id='togglePassword'
          style='cursor: pointer; position: absolute; top: 15px; right: 10px; color: #7B7C85; font-size: 17px;'
          @click='togglePassword'
          :title='locales && locales.common && locales.common.show_password'
        />
      </div>
      <div class='login-form__error' v-if="errors.has('password')">
        {{ errors.first('password') }}
      </div>
    </div>
    <div class='login-form__button-box'>
      <button
        class='theme-btn theme-btn--theme theme-btn--block'
        :class="{ 'theme-btn--theme-disabled': isLoading }"
        :disabled='isLoading'
        @click='login(email, password)'
      >
        {{ locales && locales.common && locales.common.login }}
      </button>
    </div>
    <!-- <div class='login-form__button-divider'>
      <span class='login-form__button-divider-text'>{{ locales && locales.common && locales.common.or }}</span>
    </div> -->
    <!-- <div class='login-form__button-box'>
      <a href='/redirect' class='theme-btn theme-btn--info theme-btn--block'>
        <i class='icon-facebook' style='font-size: 20px;'/>
        <span>{{ locales && locales.common && locales.common.continue_with_facebook }}</span>
      </a>
    </div> -->
    <div class='login-form__bottom'>
      {{ locales && locales.common && locales.common.dont_have_account }}
      <div class='login-form__bottom-note'>
        <a :href='createLink' class='theme-btn theme-btn--text'>
          {{ locales && locales.common && locales.common.create_account }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      createLink: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        email: '',
        password: '',
        capsLockEnabled: null,
        isTouchDevice: false,
        isLoading: false,
      };
    },
    mounted() {
      this.checkTouchDevice();
    },
    computed: {
      ...mapGetters(['locales']),
    },
    methods: {
      checkTouchDevice() {
        var md = new MobileDetect(window.navigator.userAgent);
        if (
          (md.mobile() !== '' && md.mobile() !== null) ||
          (md.tablet() !== '' && md.tablet() !== null)
        ) {
          this.isTouchDevice = true;
        }
      },
      capsLockToggle(e) {
        if (this.isTouchDevice) return;
        if (e.keyCode == 20 && this.capsLockEnabled !== null) {
          this.capsLockEnabled = !this.capsLockEnabled;
        }
      },
      getChar(e) {
        if (e.which == null) {
          return String.fromCharCode(e.keyCode); // IE
        }
        if (e.which != 0 && e.charCode != 0) {
          return String.fromCharCode(e.which); // rest
        }
        return null;
      },
      checkCaps(e) {
        if (this.isTouchDevice) return;
        var chr = this.getChar(e);
        if (!chr) return;
        if (chr.toLowerCase() == chr.toUpperCase()) return;
        this.capsLockEnabled =
          (chr.toLowerCase() == chr && e.shiftKey) ||
          (chr.toUpperCase() == chr && !e.shiftKey);
      },
      togglePassword() {
        var togglePassword = $('#togglePassword');
        var password = togglePassword.parent().find('[name=\'password\']').first();
        // toggle the type attribute
        var type = password.attr('type') === 'password' ? 'text' : 'password';
        password.attr('type', type);
        // toggle the eye / eye slash icon
        togglePassword.toggleClass('fa-eye');
        togglePassword.toggleClass('fa-eye-slash');
      },
      goToForgotPassword() {
        this.$emit('goToForgotPassword');
      },
      login(email, password) {
        if (this.isLoading) return;
        this.isLoading = true;
        // A refusal from the previous attempt is not this input's.
        this.errors.remove('email');
        this.$validator.validateAll().then((valid) => {
          if (!valid) {
            this.isLoading = false;
            return;
          }
          this.$store.dispatch('authLogin', {email, password})
            .then((result) => {
              const emailErrors = result && result.errors && result.errors.email;
              if (emailErrors && emailErrors.length) {
                this.errors.add({field: 'email', msg: emailErrors[0]});
              }
            })
            .finally(() => { this.isLoading = false; });
        });
      },
    },
  };
</script>
